export const createDeletePortalForm = token => "marketplaceDeletePortalForm" + token;
export const createEditPortalForm = token => "marketplaceEditPortalForm" + token;